var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticStyle:{"position":"absolute","bottom":"0","right":"200px"},attrs:{"src":"/img/work-in-progress.png","max-height":"400","contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }